<template>
    <b-row>
        <b-col lg="6" cols="12">
            <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-group 
                    label="ชื่อราคางาน"
                >
                    <b-form-input 
                        v-model="form.job_name" 
                        placeholder="ระบุชื่อราคางาน"
                        :state="!errors.length ? null : false"
                    />
                    <b-form-invalid-feedback>
                        {{ errors[0] }}
                    </b-form-invalid-feedback>
                </b-form-group>
            </ValidationProvider>
        </b-col>
        <b-col lg="6" cols="12">
            <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                <b-form-group 
                    label="รายชื่อลูกค้า/บริษัท"
                >
                    <multiselect
                        v-model="form.customer"
                        deselect-label="Can't remove this value"
                        track-by="id"
                        label="shop_name"
                        placeholder="เลือกรายชื่อลูกค้า"
                        :options="customerList"
                        :allow-empty="false"
                        :class="{
                            'custom-select-error': errors[0]
                        }"
                        @select="$emit('getCustomerRoutes', $event)"
                    >
                    </multiselect>
                    <p class="custom-meassage-error" v-if="errors[0]">
                        {{ errors[0] }}
                    </p>
                </b-form-group>
            </ValidationProvider>
        </b-col>
    </b-row>
</template>

<script>
import customerServices from "@/api/customer.service.js";
import { ValidationProvider } from "vee-validate";

export default {
    props: {
        form: {
            type: Object,
            default: () => {}
        }
    },
    components:{
        ValidationProvider
    },
    data () {
        return {
            customerList: []
        }
    },
    async created() {
        await this.getCustomerList();
    },
    methods: {
        async getCustomerList() {
            try {
                const response = await customerServices.getCustomerList();
                this.customerList = response.data.data;
            } catch (error) {}
        },
    }
}
</script>
